import React, { useContext } from 'react';

export const analyticsContext = React.createContext({});

export const useAnalyticsContext = () => useContext(analyticsContext);
